import {downloadZip} from 'client-zip';
import {FileModel} from "@/src/components/files/files";
import {API_URL} from "../../api/apiBase";

// https://github.com/Touffy/client-zip

export async function makeZipfromUrls(files: FileModel[]) {
    /***
     *
     * IDEALLLY - we stream signed urls from server.
     *      get a new link,
     *      add to a queue and start downloading
     *      pipe the download into the zip...
     *
     * ok... signed urls are just terrible.
     *
     * https://github.com/Touffy/client-zip
     *
     * need object with the properties:
     * name: the file name ; optional if your input is a File or a Response because they have relevant metadata
     * lastModified: last modification date of the file (defaults to new Date() unless the input is a File or Response with a valid "Last-Modified" header)
     * input: something that contains your data; it can be a File, a Blob, a Response,
     * some kind of ArrayView or a raw ArrayBuffer,
     * a ReadableStream<Uint8Array> (yes, only Uint8Arrays, but most APIs give you just that type anyway),
     * an AsyncIterable<ArrayBuffer | ArrayView | string>, … or just a string.
     *
     *
     * https://github.com/jimmywarting/StreamSaver.js/issues/106
     *
     * */

    const dls = []
    for (let i = 0; i < files.length; i++) {
        dls.push(await fetch(files[i].url))
    }

    // @ts-ignore
    console.log('here',)
    const blob = await downloadZip(dls).blob()
    console.log('blobbed',)
    // temp link e
    const link = document.createElement("a")
    console.log('created ',)
    link.href = URL.createObjectURL(blob)
    link.download = "test.zip"
    link.click()
    link.remove()
}

function proc(folder_id:string, token:string) {
    // Step 1: Open WebSocket connection
    const socket = new WebSocket(`wss://${API_URL}/files/stream_links/v1/${folder_id}/${token}`, );

// Step 2: Define an array to store ArrayBuffer responses
    const arrayBufferResponses = [];

// Step 3: Function to handle the multipart response and store it in ArrayBuffer
    async function fetchMultipart(url:string) {
        const response = await fetch(url);
        if (response.ok && response.body) {

            const reader = response.body.getReader();
            const chunks = [];
            let done = false;

            // Step 4: Read the stream until fully consumed
            while (!done) {
                const {done: isDone, value} = await reader.read();
                if (value) {
                    chunks.push(value);
                }
                done = isDone;
            }

            // Step 5: Concatenate chunks into a single ArrayBuffer
            const arrayBuffer = new Blob(chunks).arrayBuffer();
            arrayBufferResponses.push(await arrayBuffer);
        } else {
            console.error('Failed to fetch:', response.status);
        }
    }

// Step 6: WebSocket message handler for receiving URLs
    socket.onmessage = (event) => {
        const url = event.data; // Assuming each message from the socket contains a URL
        fetchMultipart(url).catch(error => console.error('Error fetching multipart:', error));
    };

// Step 7: Handle WebSocket errors
    socket.onerror = (error) => {
        console.error('WebSocket error:', error);
    };

// Step 8: Close the WebSocket connection if needed
    socket.onclose = () => {
        console.log('WebSocket closed');
    };

}